<template>
  <section>
    <div class="action-buttons">
      <div
        class="button-add-campaign"
        v-if="!modifiedRows.length"
      >
        <button
          class="button is-success is-medium"
          id="clear"
          @click="$parent.isComponentModalActive = true"
        >
          <span><i class="fal fa-plus-circle"></i> Ajouter une Vente</span>
        </button>
      </div>
      <div class="action-button">
        <button
          v-if="checkedRows.length"
          class="button field is-danger is-medium"
          id="clear"
          @click="deleteChecked"
          :disabled="!checkedRows.length"
        >
          <span>Supprimer</span>
        </button>
      </div>
      <div class="action-button">
        <button
          v-if="modifiedRows.length"
          class="button field is-green is-medium"
          id="clear"
          @click="validateModifications"
          :disabled="!modifiedRows.length"
        >
          <span><i class="fal fa-check"></i> Valider les modifications</span>
        </button>
      </div>
      <div class="action-button">
        <button
          v-if="modifiedRows.length"
          class="button field is-danger is-medium"
          id="clear"
          @click="cancelModifications"
          :disabled="!modifiedRows.length"
        >
          <span><i class="fal fa-times"></i> Annuler les modifications</span>
        </button>
      </div>
    </div>

    <div>
      <b-field
        class="search-field"
        label="Rechercher : "
      >
        <b-input
          type="texte"
          placeholder="Recherche un opérateur"
          v-model="filterEntry"
          @input="addFilter()"
          :disabled="isLoading"
        ></b-input>
      </b-field>
    </div>
    <div class="filter-bar">
      <b-datepicker
        class="b-date-picker"
        v-model="goalDate"
        :focused-date="goalDate"
        :month-names="['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Decembre']"
        :day-names="['D', 'L', 'Ma', 'Me', 'J', 'V', 'S']"
        @input="dateSelected"
        :min-date="minDate"
        :max-date="maxDate"
        :first-day-of-week="1"
        indicators="dots"
        :events="events"
        :unselectable-days-of-week="[0, 6]"
        placeholder="Filtrer par Objectif"
      >
      </b-datepicker>

      <b-select
        placeholder="Filtrer par Campagne"
        v-model="filterCampaign"
        style="padding-left: 20px;"
        @input="addFilter()"
      >
        <option
          v-for="campaign in campaigns"
          :key="campaign.id"
          :value="campaign"
        >{{campaign.name}}</option>
      </b-select>

      <b-select
        placeholder="Filtrer par Sous-Campagne"
        v-model="filterSubCampaign"
        v-if="filterCampaign && filterCampaign.sub_campaigns.length"
        style="padding-left: 20px;"
        @input="addFilter()"
      >
        <option
          v-for="sub_campaign in filterCampaign.sub_campaigns"
          :key="sub_campaign.id"
          :value="sub_campaign.id"
        >{{sub_campaign.name}}</option>
      </b-select>

      <b-select
        v-if="isAdmin[0]"
        placeholder="Filtrer par Weezy"
        v-model="filterWeezy"
        style="padding-left: 20px;"
        @input="addFilter()"
      >
        <option
          v-for="weezy in weezys"
          :key="weezy.id"
          :value="weezy.id"
        >{{weezy.name}}</option>
      </b-select>
      <div
        v-if="filterEntry != '' || filterGoal != null || filterCampaign != null || filterWeezy != null"
        class="filter-erase"
      >
        <button
          class="button field is-info is-medium"
          id="clear"
          style="margin-left: 20px;"
          @click="resetAllFilters()"
        >
          <span style="font-size: 1em;">Effacer les filtres</span>
        </button>
      </div>
      <b-select
        v-model="perPage"
        style="padding-left: 20px;"
      >
        <option value="10">10 par page</option>
        <option value="20">20 par page</option>
        <option value="30">30 par page</option>
      </b-select>
    </div>

    <b-modal
      :active.sync="$parent.isComponentModalActive"
      has-modal-card
    >
      <form action="add-weezy">
        <div
          class="modal-card"
          style="min-width: 480px;"
        >
          <header
            class="modal-card-head"
            style="text-align: center"
          >
            <p class="modal-card-title">Ajouter une Vente</p>
          </header>
          <section class="modal-card-body">
            <div class="modal-line">
              <b-field
                class="b-modal-select-field"
                label="Weezy associé :"
                required
              >
                <b-select
                  :disabled="!isAdmin[0]"
                  placeholder="Choisir le weezy"
                  v-model="formWeezyId"
                  :required="true"
                >
                  <option
                    v-for="weezy in weezys"
                    :key="weezy.id"
                    :value="weezy.id"
                  >{{weezy.name}}</option>
                </b-select>
              </b-field>

              <b-field
                label="Opérateur associé :"
                required
              >
                <b-select
                  placeholder="Choisir l'Opérateur"
                  v-model="formUserId"
                  :required="true"
                  :disabled="formWeezyId == ''"
                >
                  <option
                    v-for="user in weezyUsers"
                    :key="user.id"
                    :value="user.id"
                  >{{user.name}} {{user.surname}}</option>
                </b-select>
              </b-field>
            </div>

            <div class="modal-line">

              <b-field label="Sous-campagne optionnelle :">
                <b-select
                  placeholder="Sous-campagne"
                  v-model="formSubCampaignId"
                  v-if="formWeezyId != '' && weezys.length && weezyCampaign[0]"
                >
                  <option
                    v-for="sub_campaign in weezyCampaign[0].sub_campaigns"
                    :key="sub_campaign.id"
                    :value="sub_campaign.id"
                  >{{sub_campaign.name}}</option>
                </b-select>
              </b-field>

              <b-field label="Heure de Vente :">
                <b-timepicker
                  v-model="formTime"
                  inline
                ></b-timepicker>
              </b-field>
            </div>
          </section>
          <footer
            class="modal-card-foot"
            style="justify-content: space-evenly"
          >
            <button
              class="button is-danger"
              type="button"
              @click="dismissForm"
            ><span><i class="fal fa-times"></i> Annuler</span></button>
            <button
              class="button is-success"
              type="button"
              @click="submitFormData"
            ><span><i class="fal fa-check"></i> Ajouter</span></button>
          </footer>
        </div>
      </form>
    </b-modal>

    <b-modal
      :active.sync="$parent.isDeleteConfirmationModalActive"
      has-modal-card
    >
      <form action="add-weezy">
        <div
          class="modal-card"
          style="width: 480px;"
        >
          <header
            class="modal-card-head"
            style="text-align: center"
          >
            <p class="modal-card-title">Confirmer la suppression ?</p>
          </header>
          <footer
            class="modal-card-foot"
            style="justify-content: space-evenly"
          >
            <button
              class="button is-danger"
              type="button"
              @click="dismissForm"
            ><span><i class="fal fa-times"></i> Annuler</span></button>
            <button
              class="button is-success"
              type="button"
              @click="confirmDelete"
            ><span><i class="fal fa-check"></i> Confirmer</span></button>
          </footer>
        </div>
      </form>
    </b-modal>

    <b-table
      class="b-table"
      style='list-style-type: none;'
      :data="myData"
      :striped="true"
      :hoverable="true"
      :loading="isLoading"
      :checked-rows.sync="checkedRows"
      :checkable="checkable"
      :mobile-cards="false"
    >

      <template
        slot-scope="props"
        slot="header"
      >
        <b-tooltip
          :active="!!props.column.meta"
          :label="props.column.meta"
        >
          {{ props.column.label }}
        </b-tooltip>
      </template>

      <template slot-scope="props">
        <b-table-column
          meta="Objectif dans lequel la vente est déclarée"
          field="goal_date"
          label="Objectif Quotidien"
          :centered="true"
        >
          {{getGoalDate(props.row.goal_id)}}
        </b-table-column>

        <b-table-column
          meta="Heure à laquelle la vente fut effectuée"
          label="Heure de Ventes"
          :centered="true"
        >
          {{timeFormatter(props.row.creation_date_time)}}
        </b-table-column>

        <b-table-column
          meta="Campagne dans laquelle la vente est déclarée"
          field="campaigns"
          label="Campagne"
          :centered="true"
        >
          {{getCampaignName(props.row.campaign_id)}}
        </b-table-column>

        <b-table-column
          meta="Sous Campagne dans laquelle la vente est déclarée"
          field="sub_campaign"
          label="Sous-Campagne"
          :centered="true"
        >

          <b-select
            v-if="getSubCampaigns(props.row.campaign_id).length"
            placeholder="Choisir la sous-campagne"
            v-model="props.row.sub_campaign_id"
            :required="true"
            @input="toggleModified(props.row)"
          >
            <option
              :key="0"
              :value="null"
            >Aucune</option>
            <option
              v-for="subcampaign in getSubCampaigns(props.row.campaign_id)"
              :key="subcampaign.id"
              :value="subcampaign.id"
            >{{subcampaign.name}}</option>
          </b-select>
        </b-table-column>

        <b-table-column
          meta="Nom du Weezy sur lequel la vente est déclarée"
          v-if="isAdmin[0]"
          field="goal_id"
          label="Weezy"
          :centered="true"
        >
          {{getWeezyName(props.row.weezy_id)}}
        </b-table-column>

        <b-table-column
          meta="Nom de l'opérateur ayant effectué la vente"
          field="user_id"
          label="Opérateur"
        >
          <b-select
            placeholder="Choisir l'opérateur"
            v-model="props.row.user_id"
            :required="true"
            @input="toggleModified(props.row)"
          >
            <option
              v-for="user in users"
              :key="user.id"
              :value="user.id"
            >{{user.name}} {{user.surname}}</option>
          </b-select>
        </b-table-column>
      </template>

      <template slot="empty">
        <section class="section">
          <div
            v-if="!isLoading"
            class="content has-text-grey has-text-:centered"
          >
            <p>Pas de Ventes</p>
          </div>
        </section>
      </template>
    </b-table>

    <div
      v-if="pages_count > 1"
      class="w-100 flex mb3"
    >
      <table-paginator
        @page-change="paginationPageChange"
        ref="paginationBottom"
        :per_page="perPage"
        :pages_count="pages_count"
      ></table-paginator>
    </div>
  </section>
</template>

<script>
import table_paginator from "@/components/elements/table-paginator";

import http from "@/modules/request";
import _ from "lodash";

export default {
  name: "GoalsTable",
  components: { "table-paginator": table_paginator },
  props: [
    "sales",
    "users",
    "goals",
    "checkable",
    "weezys",
    "campaigns",
    "isAdmin",
    "pages_count"
  ],
  data: () => {
    return {
      isEmpty: false,
      isLoading: true,
      checkedRows: [],
      modifiedRows: [],
      myData: [],
      storedSales: [],
      formWeezyId: "",
      formUserId: "",
      formSubCampaignId: "",
      formTime: new Date(),
      filterEntry: "",
      filterUser: null,
      filterWeezy: null,
      filterGoal: null,
      filterCampaign: null,
      filteredCampaign: null,
      filterSubCampaign: null,
      currentPage: 1,
      perPage: 10,
      year: new Date().getFullYear(),
      month: new Date().getMonth(),
      minDate: new Date(),
      maxDate: new Date(),
      goalDate: null,
      events: []
    };
  },
  watch: {
    sales: function(newVal, oldVal) {
      // watch it
      var sorted = JSON.parse(JSON.stringify(this.sales)).sort(
        (a, b) =>
          new Date(b.creation_date_time) - new Date(a.creation_date_time)
      );
      this.myData = sorted;
      this.isLoading = false;
      this.storedSales = JSON.parse(JSON.stringify(this.myData));

      if (!this.isAdmin[0]) {
        this.formWeezyId = this.isAdmin[1];
      }
      this.getEvents();
    },
    perPage: function(newVal, oldVal) {
      this.paginationPageChange(1);
    }
  },
  computed: {
    weezyUsers: function() {
      return _.pickBy(
        this.users,
        function(u) {
          return u.weezy_id == this.formWeezyId;
        }.bind(this)
      );
    },
    weezyCampaign: function() {
      return _.pickBy(
        this.campaigns,
        function(c) {
          return (
            c.id ==
            this.weezys.filter(el => el.id == this.formWeezyId)[0].campaign_id
          );
        }.bind(this)
      );
    }
  },

  methods: {
    // This method is used to display the list of possible subcampaigns of a given campaign
    getSubCampaigns(fromCampaignId) {
      if (fromCampaignId)
        for (var l = 0; l < this.campaigns.length; l++) {
          if (fromCampaignId == this.campaigns[l].id) {
            return this.campaigns[l].sub_campaigns;
          }
        }
      return [];
    },

    paginationPageChange(page) {
      this.currentPage = page;
      this.$emit("page-change", page);
      this.goToPage(page);
    },
    goToPage(page) {
      if (this.$refs.paginationBottom) this.$refs.paginationBottom.page = page;
    },

    filterByWeezy(entry) {
      return entry.filter(e => e.weezy_id && e.weezy_id == this.filterWeezy);
    },
    filterByGoal(entry) {
      return entry.filter(e => e.goal_id && e.goal_id == this.filterGoal);
    },
    filterByCampaign(entry) {
      return entry.filter(
        e => e.campaign_id && e.campaign_id == this.filterCampaign.id
      );
    },
    filterBySubCampaign(entry) {
      return entry.filter(
        e => e.sub_campaign_id && e.sub_campaign_id == this.filterSubCampaign
      );
    },
    addFilter() {
      this.$emit("add-filter");
    },
    resetAllFilters() {
      this.filterEntry = "";
      this.filterUser = null;
      this.filterWeezy = null;
      this.filterGoal = null;
      this.goalDate = null;
      this.filterCampaign = null;
      this.filterSubCampaign = null;
      this.addFilter();
    },
    filteredResults(string) {
      return this.storedSales.filter(
        e =>
          (e.weezy_id &&
            this.getWeezyName(e.weezy_id)
              .toLowerCase()
              .includes(string.toLowerCase())) ||
          (this.getCampaignName(e.campaign_id) &&
            this.getCampaignName(e.campaign_id)
              .toLowerCase()
              .includes(string.toLowerCase())) ||
          (this.getGoalDate(e.goal_id) &&
            this.getGoalDate(e.goal_id).includes(string)) ||
          this.timeFormatter(e.creation_date_time).includes(string) ||
          (this.getUserName(e.user_id) &&
            this.getUserName(e.user_id)
              .toLowerCase()
              .includes(string.toLowerCase()))
      );
    },
    resetMyData() {
      this.myData = [{ id: "", goal_id: "" }];
      this.resetFormData();
    },
    timeFormatter(value) {
      var date = new Date(value);
      var hours = this.leadZero(date.getHours());
      var minutes = this.leadZero(date.getMinutes());
      return hours + ":" + minutes;
    },
    dateFormatter(value, onlyDate = false) {
      var date = new Date(value);
      var years = date.getFullYear();
      var months = this.leadZero(date.getMonth() + 1);
      var days = this.leadZero(date.getDate());
      return days + "-" + months + "-" + years;
    },
    leadZero(n) {
      return n > 9 ? n : "0" + n;
    },
    deleteChecked() {
      this.$parent.isDeleteConfirmationModalActive = true;
    },
    confirmDelete() {
      this.$parent.deleteCheckedRows(this.checkedRows);
      this.checkedRows = [];
    },
    toggleModified(raaw) {
      var sorted = JSON.parse(JSON.stringify(this.sales)).sort(
        (a, b) =>
          new Date(b.creation_date_time) - new Date(a.creation_date_time)
      );
      this.storedSales = JSON.parse(JSON.stringify(sorted));

      var modified = false;
      this.modifiedRows.push(raaw);
      for (var j = 0; j < this.modifiedRows.length; j++) {
        var row = this.modifiedRows[j];
        for (var i = 0; i < this.storedSales.length; i++) {
          var sale = this.storedSales[i];
          if (sale.id == row.id) {
            if (
              !(
                sale.user_id == row.user_id &&
                sale.goal_id == row.goal_id &&
                sale.sub_campaign_id == row.sub_campaign_id
              )
            ) {
              modified = true;
            }
          }
        }
        if (!modified) {
          this.modifiedRows = [];
        }
      }
    },
    validateModifications() {
      this.$parent.modifyRows(this.modifiedRows);
      setTimeout(() => {
        this.modifiedRows = [];
      }, 100);
    },
    cancelModifications() {
      this.$parent.getSales(this.currentPage);
      setTimeout(() => {
        this.modifiedRows = [];
        this.checkedRows = [];
        this.myData = this.storedSales;
      }, 100);
    },
    getWeezyName(formWeezyId) {
      for (var i = 0; i < this.weezys.length; i++) {
        if (formWeezyId == this.weezys[i].id) return this.weezys[i].name;
      }
    },
    getCampaignName(fromCampaignId) {
      for (var k = 0; k < this.campaigns.length; k++) {
        if (fromCampaignId == this.campaigns[k].id) {
          return this.campaigns[k].name;
        }
      }
    },
    getSubCampaignName(fromSubCampaignId) {
      if (fromSubCampaignId)
        for (var l = 0; l < this.campaigns.length; l++) {
          for (var m = 0; m < this.campaigns[l].sub_campaigns.length; m++) {
            if (fromSubCampaignId == this.campaigns[l].sub_campaigns[m].id) {
              return this.campaigns[l].sub_campaigns[m].name;
            }
          }
        }
      return "-";
    },
    getGoalDate(fromGoalId) {
      for (var i = 0; i < this.goals.length; i++) {
        if (fromGoalId == this.goals[i].id) {
          return this.dateFormatter(this.goals[i].creation_date_time);
        }
      }
    },
    getUserName(fromUserId) {
      for (var i = 0; i < this.users.length; i++) {
        if (fromUserId == this.users[i].id) {
          return (
            this.users[i].name +
            " " +
            this.users[i].surname +
            " " +
            this.users[i].name
          );
        }
      }
    },
    submitFormData() {
      if (this.formWeezyId == "" || this.formUserId == "") {
        this.$parent.errorToast("Merci de remplir tous les champs");
      } else {
        var goalId = "";
        for (var i = this.goals.length; i > 0; i--) {
          var goal = this.goals[i - 1];
          if (
            this.formWeezyId == goal.weezy_id &&
            !goal.is_hidden &&
            goal.is_active
          ) {
            goalId = goal.id;
          }
        }
        if (goalId == "") {
          return this.$parent.errorToast(
            "Le Weezy sélectionné n'a pas d'objectif activé"
          );
        }
        var tempTime = new Date(JSON.parse(JSON.stringify(this.formTime)));
        tempTime = tempTime.setHours(tempTime.getHours());
        this.$parent.addNewRow({
          goal_id: goalId,
          weezy_id: this.formWeezyId,
          user_id: this.formUserId,
          sub_campaign_id: this.formSubCampaignId,
          creation_time: tempTime,
          creation_date: this.getGoalDate(goalId)
        });

        setTimeout(() => {
          this.storedSales = JSON.parse(JSON.stringify(this.sales));
          this.modifiedRows = [];
          this.checkedRows = [];
          this.resetFormData();
        }, 50);
      }
    },
    dismissForm() {
      this.$parent.isDeleteConfirmationModalActive = false;
      this.$parent.isComponentModalActive = false;
      this.resetFormData();
    },
    resetFormData() {
      (this.formWeezyId = ""),
        (this.formUserId = ""),
        (this.formTime = new Date());
      this.sales.sort(
        (a, b) =>
          new Date(b.creation_date_time) - new Date(a.creation_date_time)
      );
    },
    sortByDate(a, b, isAsc) {
      if (isAsc) {
        return new Date(b.creation_date_time) - new Date(a.creation_date_time);
      } else {
        return new Date(a.creation_date_time) - new Date(b.creation_date_time);
      }
    },
    sortByCampaign(a, b, isAsc) {
      if (isAsc) {
        return this.getCampaignName(b.campaign_id).toLowerCase() <
          this.getCampaignName(a.campaign_id).toLowerCase()
          ? -1
          : 1;
      } else {
        return this.getCampaignName(b.campaign_id).toLowerCase() >
          this.getCampaignName(a.campaign_id).toLowerCase()
          ? -1
          : 1;
      }
    },
    sortBySubCampaign(a, b, isAsc) {
      if (isAsc) {
        return this.getSubCampaignName(b.sub_campaign_id).toLowerCase() <
          this.getSubCampaignName(a.sub_campaign_id).toLowerCase()
          ? -1
          : 1;
      } else {
        return this.getSubCampaignName(b.sub_campaign_id).toLowerCase() >
          this.getSubCampaignName(a.sub_campaign_id).toLowerCase()
          ? -1
          : 1;
      }
    },
    sortByWeezy(a, b, isAsc) {
      if (isAsc) {
        return this.getWeezyName(b.weezy_id).toLowerCase() <
          this.getWeezyName(a.weezy_id).toLowerCase()
          ? -1
          : 1;
      } else {
        return this.getWeezyName(b.weezy_id).toLowerCase() >
          this.getWeezyName(a.weezy_id).toLowerCase()
          ? -1
          : 1;
      }
    },
    dateSelected() {
      if (this.goalDate != null) {
        var forrmatedGoalDate =
          new Date(this.goalDate).getFullYear() +
          "/" +
          new Date(this.goalDate).getMonth() +
          "/" +
          new Date(this.goalDate).getDate();
        for (var i = 0; i < this.goals.length; i++) {
          var forrmatedThatDate =
            new Date(this.goals[i].activation_date_time).getFullYear() +
            "/" +
            new Date(this.goals[i].activation_date_time).getMonth() +
            "/" +
            new Date(this.goals[i].activation_date_time).getDate();

          if (forrmatedGoalDate == forrmatedThatDate) {
            this.filterGoal = this.goals[i].id;
          }
        }
      }
      this.addFilter();
    },
    getEvents() {
      this.minDate = new Date(
        JSON.parse(JSON.stringify(this.sales)).sort(
          (b, a) =>
            new Date(b.creation_date_time) - new Date(a.creation_date_time)
        )[0].creation_date_time
      );
      var tempEvents = [];

      for (var i = 0; i < this.myData.length; i++) {
        var saleDate = new Date(this.myData[i].creation_date_time);
        var tempEntry = {
          date: new Date(
            saleDate.getFullYear(),
            saleDate.getMonth(),
            saleDate.getDate()
          ),
          type: "is-danger"
        };
        var toAdd = true;
        for (var j = 0; j < tempEvents.length; j++) {
          if (
            JSON.stringify(tempEvents[j].date) == JSON.stringify(tempEntry.date)
          ) {
            toAdd = false;
          }
        }

        if (toAdd) {
          tempEvents.push(tempEntry);
        }
      }
      this.events = tempEvents;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media screen and (max-width: 768px) {
  .action-buttons {
    display: flow-root;
  }

  .datepicker {
    margin-left: 20px;
  }

  .action-buttons,
  .action-button {
    float: unset;
  }

  .b-table {
    margin-top: 2em;
  }

  .filter-bar {
    display: table-caption;
    line-height: 2em;
    margin-left: -20px;
    margin-top: 1em;
  }
}

.saleRow {
  text-align: center;
}

.b-table {
  width: auto;
}

.b-input-number {
  width: 50px;
  margin-left: 15px;
}

.button-add-campaign {
  float: right;
  padding-right: 10%;
}

.action-button {
  float: right;
  padding-right: 10px;
}

.modal-line {
  display: flex;
  justify-content: space-between;
}

.modal-input-field {
  width: 175px;
  padding-left: 0px;
}

.b-modal-input-number {
  width: 100px;
}

.b-modal-select-field {
  width: 200px;
}

.pagination-list ul {
  list-style-type: none !important;
  font-size: 3em;
}

.action-buttons {
  margin-top: 10px;
}
</style>